import React, {useEffect, useState} from "react";
import {DragDropContext, Droppable} from "react-beautiful-dnd";
import {reorderKeysByDragDrop} from "../../utils/helpers";
import CIQuestionOptionNew from "./CIQuestionOptionNew";
import classes from "../questions.module.css";
import {GRADE_SCHEMA} from "../../utils/constants";


export default function CIQuestionNew({
                                          gradeSchema=GRADE_SCHEMA.GRADED.key,
                                          setQuestions,
                                          questions,
                                          selectedQuestion,
                                      }) {
    const {optionsMap, serialNo} = selectedQuestion;

    const initializeCollapse = () => {
        const res = {};

        optionsMap.forEach((option, index) => {
            res[index] = true;
        });
        return res;
    }

    const [collapseStatusObj, setCollapseStatusObj] = useState(() => initializeCollapse());

    useEffect(() => {
        setCollapseStatusObj(initializeCollapse);
    }, [serialNo]);

    useEffect(() => {
        if (optionsMap.length > Object.keys(collapseStatusObj).length) {
            let copy = {};
            optionsMap.forEach((option, index) => {
                copy[index] = collapseStatusObj.hasOwnProperty(index) ? collapseStatusObj[index] : true;
            })
            setCollapseStatusObj(copy);
        }
    }, [optionsMap]);

    const handleAnswerOrderChange = (result) => {
        if (!result.destination || result.source.index === result.destination.index) {
            return;
        }

        let newQuestions = [];
        let copy = {};
        questions.forEach((q) => {
            if (q.serialNo !== serialNo) {
                newQuestions.push(q);
            } else {
                const questionCopy = JSON.parse(JSON.stringify(q));
                let reorderKeys = reorderKeysByDragDrop(result.source.index, result.destination.index, Object.keys(questionCopy.optionsMap));
                let newOptionsMap = [];
                let newCorrectAnswers = [];
                for (let i = 0; i < reorderKeys.length; i++) {
                    newOptionsMap[i] = questionCopy.optionsMap[parseInt(reorderKeys[i])];
                    copy[i] = collapseStatusObj[parseInt(reorderKeys[i])]
                    if (questionCopy.correctAnswers.includes(parseInt(reorderKeys[i]))) {
                        newCorrectAnswers.push(i);
                    }
                }

                questionCopy.optionsMap = newOptionsMap;
                questionCopy.correctAnswers = newCorrectAnswers.sort();
                newQuestions.push(questionCopy);

            }
        });

        setCollapseStatusObj(copy);
        setQuestions(newQuestions);
    };


    return (
        <DragDropContext onDragEnd={handleAnswerOrderChange}>
            <Droppable droppableId="droppable-multiple-choice-question">
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        {...provided.dropHandleProps}
                        className={classes.optionsContainer}
                    >
                        {optionsMap.map((option, index) => (
                            <CIQuestionOptionNew
                                key={index}
                                gradeSchema={gradeSchema}
                                optionData={option}
                                selectedQuestion={selectedQuestion}
                                questions={questions}
                                setQuestions={setQuestions}
                                index={index}
                                collapsed={!collapseStatusObj.hasOwnProperty(index) || collapseStatusObj[index]}
                                setCollapsed={(status) => {
                                    let copy = JSON.parse(JSON.stringify(collapseStatusObj));
                                    copy[index] = status;
                                    setCollapseStatusObj(copy);
                                }}

                                deleteCollapsed={() => {
                                    let copy = {};
                                    Object.entries(collapseStatusObj).forEach(([key, value]) => {
                                        let realKey = parseInt(key);
                                        if (realKey !== index) {
                                            if (realKey > index) {
                                                const newKey = realKey - 1;
                                                copy[newKey] = value;
                                            } else {
                                                copy[realKey] = value;
                                            }
                                        }
                                    });
                                    setCollapseStatusObj(copy);
                                }}

                            />
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}
